import { useContext, useEffect } from "react";
import { AppContext, SET_PAGE_STATE, SocketCommand, socketManager } from "../../../components/AppProvider";
import { _O } from "../../../modules/utils";
import { openLoadingLayer } from "../Layer/Loading";

export const downloadFile = (
    userToken, phoneOS, bizType
    , bizName, fileSeq, dnFileNm
    , fileExt, fileSize, rtnUrl
    , dnYn, callbackHandle, hsptSharYn
    , seqNo, hsptNm, schdlNm
) => {
    
    // native API 호출시 필요한 데이터
    // bizType == code형식
    // 파일여부: 전자처방전:EP, 개인진료기록:PR, 제증명:PF
    // commonDownload Parameter
    //   userToken, bizType, fileSeq, fileName, fileExt, fileSize, returnURL, 갤러리 저장여부(true, false), 다운로드 후 조회여부 (true, false)
    if(bizType === "PF") {
        if (phoneOS === "ANDROID") {
            if(dnYn == 'N') {
                console.log("DOWNLOAD");
                socketManager(SocketCommand.COMMON_FILE_DOWNLOAD, callbackHandle, putJsonData(userToken, bizType, bizName, fileSeq, fileExt, fileSize, rtnUrl, true, true, hsptSharYn, seqNo, hsptNm, schdlNm));
            } else {
                // window.java.commonFileView(bizType, bizName, dnFileNm, fileExt);
                socketManager(
                    SocketCommand.COMMON_FILE_VIEW
                    , callbackHandle
                    , putJsonData2(bizType, bizName, dnFileNm, fileExt, hsptSharYn, seqNo, hsptNm, schdlNm, rtnUrl, hsptSharYn, seqNo, hsptNm, schdlNm)
                )
            }
        } else {
            if(dnYn == 'N') {
                // webkit.messageHandlers.sendTrsmId.commonDownload(userToken, bizType, bizName, fileSeq, fileExt, fileSize, rtnUrl, true, true);
                socketManager(SocketCommand.COMMON_FILE_DOWNLOAD, callbackHandle, putJsonData(userToken, bizType, bizName, fileSeq, fileExt, fileSize, rtnUrl, true, true, hsptSharYn, seqNo, hsptNm, schdlNm))
            } else {
                // webkit.messageHandlers.sendTrsmId.commonFileView(bizType, bizName, dnFileNm, fileExt);
                socketManager(
                    SocketCommand.COMMON_FILE_VIEW
                    , callbackHandle
                    , putJsonData2(bizType, bizName, dnFileNm, "."+fileExt, hsptSharYn, seqNo, hsptNm, schdlNm, rtnUrl, hsptSharYn, seqNo, hsptNm, schdlNm)
                )
            }
        }
    } else {
        socketManager(SocketCommand.FILE_UPLOAD, undefined, {
            type: "download",
            userToken: userToken.toString(),
            masterKeys: [{
                masterKey1:fileSeq.toString(), masterKey2:"", masterKey3: ""
            }],
            bizType: "PR",
            bizName: "진료자료",
            bizDtlType: "",
            viewYN: "Y",
            saveExtYN: "N",
            redirectURL: "",
            colorType: "PP",
            hsptSharYn: "Y",
            bizSubType: "X"
        });
    }
}

export const downloadPfFile = ( userToken, fileSeq ) => {
    socketManager(SocketCommand.FILE_UPLOAD, undefined, {
        type: "download",
        userToken: userToken.toString(),
        masterKeys: [{
            masterKey1:fileSeq.toString(), masterKey2:"", masterKey3: ""
        }],
        bizType: "PF",
        bizName: "제증명",
        bizDtlType: "",
        viewYN: "Y",
        saveExtYN: "N",
        redirectURL: "",
        colorType: "PP",
        hsptSharYn: "Y",
        bizSubType: "3"
    });
}

export const deleteFileList = () => {
    // bizType, fileName(JSON.ARRAY)
}

export const fileInfoToOBJ = (params) => {
    let obj = {};
    
    for (let i=0; i<params.length; i++) {
        if(i == 0) {
            obj['key'] = params[i];
        } else {
            obj['param'+i] = params[i];
        }
    }

    return JSON.stringify(obj);
}

export const fileInfoToOBJ2 = (params) => {
    let obj = {};
    let returnObj = new Array();

    for (let i=0; i<params.length; i++) {
        obj.push(params[i].filePath);
    }
    returnObj['deletaList'] = returnObj;

    return JSON.stringify(returnObj);
}

export const returnUrl = (url, periodType, startDate, endDate) => {
    // url 맨 앞 '/'는 제외해야함 (앱에서 이미 '/' 처리 되어있음)
    let returnUrl = url + '/' + periodType + '/' + startDate + '/' + endDate;
    return returnUrl;
}

export const putJsonData = (userToken, bizType, bizName, fileSeq, fileExt, fileSize, rtnUrl, saveGallery, play, hsptSharYn, seqNo, hsptNm, schdlNm) => {
    return {
        "userToken":userToken.toString()
        , "bizType":bizType
        , "bizName":bizName
        , "fileSeq":fileSeq
        , "fileExt":fileExt
        , "fileSize":fileSize
        , "returnUrl":rtnUrl
        , "saveGallery":saveGallery
        , "play":play
        , "hsptSharYn":hsptSharYn
        , "seqNo":seqNo
        , "hsptNm":hsptNm
        , "schdlNm":schdlNm
    }
}

export const putJsonData2 = (bizType, bizName, dnFileNm, fileExt, hsptSharYn, seqNo, hsptNm, schdlNm, rtnUrl) => {
    return {
        "bizType":bizType
        , "bizName":bizName
        , "dnFileNm":dnFileNm
        , "fileExt":fileExt
        , "hsptSharYn":hsptSharYn
        , "seqNo":seqNo
        , "hsptNm":hsptNm
        , "schdlNm":schdlNm
        , "returnUrl":rtnUrl
    }
}

export const uploadFile = (userinfo, bizType, bizName, bizDtlType, hsptCd) => {
    let targetArr = [];
    let targetArr2 = [];

    let masterKey1 = "";
    let masterKey2 = "";

    $('input:checkbox[name="targetCheck"]').each(function() {
        if(this.checked) {
            masterKey1 = this.value.split("!")[0];
                
            if(this.value.split("!")[1]) {
                masterKey2 = this.value.split("!")[1];
            }

            targetArr.push({
                "masterKey1":masterKey1
                , "masterKey2":masterKey2
                , "masterKey3":""
            });
        }
    });

    if($('#targetHsptCd').val() === '') {
        alert("공유할 병원을 선택하세요");
        return;
    }

    if(targetArr.length > 0) {
        socketManager(SocketCommand.FILE_UPLOAD, undefined, {"userToken":userinfo.userToken.toString(), "hsptCd":hsptCd, "masterKeys":targetArr, "subId":targetArr2,  "bizType":bizType, "bizName":bizName, "bizDtlType":bizDtlType, "hsptSharYn":"N", bizSubType:"X"});
        // socketManager(SocketCommand.FILE_UPLOAD, undefined, {"type":"upload", "userToken":userinfo.userToken.toString(), "hsptCd":$('#targetHsptCd').val().toString(), "trsmId":targetArr, "bizType":"PR", "bizName":"개인진료기록", "bizDtlType":"1"});
    } else {
        alert("선택된 파일이 없습니다.");
        return;
    }
}

export const commonFileHandle = (dispatch, type, redirectURL) => {
    if(type === "upload") {
        // setShareMode(0);
        dispatch({ type: SET_PAGE_STATE, data: {type:"share", state:0}});
    } else {
        if(redirectURL === "") {
            // setShareMode(0);
            dispatch({ type: SET_PAGE_STATE, data: {type:"reload", state:0}});
        } else {
            _O.Open("/"+redirectURL);
        }
    }
    
}